import color from './color';

export default function(context, item, opacity) {
  opacity *= (item.fillOpacity==null ? 1 : item.fillOpacity);
  if (opacity > 0) {
    context.globalAlpha = opacity;
    context.fillStyle = color(context, item, item.fill);
    return true;
  } else {
    return false;
  }
}



//////////////////
// WEBPACK FOOTER
// ./~/vega-scenegraph/src/util/canvas/fill.js
// module id = 617
// module chunks = 0